import { render } from "./contact.vue?vue&type=template&id=2403d52f&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=2403d52f&scoped=true&lang=css"

import exportComponent from "D:\\Project\\Lmm\\gw_lmm\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_6285803b7cea55eb83ef6d11bd88d191\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2403d52f"]])

export default __exports__